import { paths } from '@luxuryescapes/contract-svc-lux-loyalty'

type ServerLoyaltyActivity = paths['/api/lux-loyalty/account/activities']['get']['responses']['200']['content']['application/json']['result']['activities'][0]

function getLocalActivityType(activity: ServerLoyaltyActivity): App.LoyaltyAccountActivityType {
  switch (activity.activityType) {
    // case 'Accrual Activity':

    case 'Cancellation Activity':
      return 'cancellation'
    case 'Expire Points':
      return 'expired_points'
    case 'Expired Points Reversal':
      return 'expired_points_reversal'
    case 'Manual Adjustment':
      return 'manual'
    case 'Member Enrolment Activity':
      return 'enrolment'
    case 'Accrual Activity':
      if (activity.basePoints) {
        return 'earn_points'
      } else if (activity.statusCredits) {
        return 'earn_status_credits'
      }
      // not sure what else could accrue
      return 'other'
    case 'Redemption':
      if (activity.basePoints) {
        return activity.basePoints > 0 ? 'earn_points' : 'spend_points'
      } else if (activity.statusCredits) {
        return 'earn_status_credits'
      } if (activity.itemId) {
        return 'benefit_redemption'
      }
      return 'other'
    case 'Tier Change Activity':
      return 'tier_change'
    default:
      return 'other'
  }
}

function mapLoyaltyAccountActivity(activity: ServerLoyaltyActivity): App.LoyaltyAccountActivity {
  return {
    id: activity.id,
    date: activity.activityDate,
    type: getLocalActivityType(activity),
    description: activity.activityDescription,
    basePoints: activity.basePoints ?? 0,
    orderId: activity.orderId,
    orderItemId: activity.itemId,
    statusCredits: activity.statusCredits ?? 0,
  }
}

export default mapLoyaltyAccountActivity
